import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './components/login/login-gaurd.service';
import { LoginComponent } from './components/login/login.compnent';
import { AccessGuardService } from './services/accessguard.service';
import { DeliveryRateFinderComponent } from './components/deliveryRateFinder/DeliveryRateFinder.component';

const routes: Routes = [
    {path:'', redirectTo:'rateFinder', pathMatch:'full'},
    {path:'login', component:LoginComponent },
    {path:'login/verify', component:LoginComponent },
    {path:'', canActivateChild:[LoginGuard], children:[
        {path:'rateFinder', component:DeliveryRateFinderComponent , canActivate:[AccessGuardService]},
    ]},
    // {path:'**', redirectTo:'/login', pathMatch:'full'}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
